import { grey } from '@mui/material/colors';
import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/material/styles';
import { Table } from 'shared/mui/Table';

export const TableStyled = styled(Table)({
  '& .MuiTableCell-head': {
    padding: '13px 16px',
    lineHeight: '21px',
  },
  '& .MuiTableCell-body': {
    padding: '12px 16px',
    lineHeight: '20px',
  },
});

export const SkeletonStyled = styled(Skeleton)({
  backgroundColor: grey[300],
});
